module.exports = __webpack_public_path__ + "static/client8-9040850e510f80e8e00f8a803635a1e6.png";